/**
 * PremiumUpgradeNotice
 *
 * Upsell card prompting users to upgrade to Premium, linking to pricing.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Crown } from 'lucide-react';

export function PremiumUpgradeNotice({ title = 'Want to see more templates?', description = 'Upgrade to Premium to access our full collection of templates.', className = '' }) {
  return (
    <div className={`rounded-lg border border-gray-200 dark:border-gray-700 ${className}`}>
      <div className="flex flex-col items-center text-center p-6">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/30">
          <Crown className="h-6 w-6 text-primary-600 dark:text-primary-500" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
          {title}
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          {description}
        </p>
        <Link
          to="/pricing"
          className="inline-flex items-center justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:hover:bg-primary-500 dark:focus:ring-primary-400"
        >
          Upgrade to Premium
        </Link>
      </div>
    </div>
  );
}

export default PremiumUpgradeNotice; 